import React,{Component} from 'react';
import { BrowserRouter as  Router, Link  } from 'react-router-dom';


class InventoryDisplayProduct extends Component{
    	
       
    render() {
        
        return (
                <tr>
                    
                    <td>
                        <p>{this.props.product.product_name}</p>
                    </td>
                    <td>
                        <p>Pcs</p>
                    </td>
                    <td>
                        <p>{this.props.product.product_length}</p>
                    </td>
                    <td>
                        <p>{this.props.product.product_color}</p>
                    </td>
                    <td>
                        <p>{this.props.product.product_count}</p>
                    </td>
                    <td>
                        <Link to={`/inventory/${this.props.index}/out-product`} data-toggle="tooltip" className="btn btn-default"> Out</Link>
                        <Link to={`/inventory/${this.props.index}/view-product`} data-toggle="tooltip" className="btn btn-default"> View</Link>
                    </td>           
                  
                </tr>
	    
        );
    }
}

export default  InventoryDisplayProduct;


// WEBPACK FOOTER //
// ./src/components/InventoryDisplayProduct.js